export const calculateFooter = (items, columns, isAmount = false) => {
  if (!Array.isArray(columns)) return undefined;

  return columns.map((col) => {
    const targetField = isAmount ? 'amount' : 'hours';
    if (col.field === targetField) {
      const total = (items || []).reduce((acc, row) => {
        const raw = row && row[targetField];
        const value = raw === null || raw === undefined ? '' : String(raw).trim();
        if (!value) return acc;
        const numeric = parseFloat(value.replace(/[,$\s]/g, '') || '0');
        return Number.isNaN(numeric) ? acc : acc + numeric;
      }, 0);

      return isAmount
        ? `Total Amount: $${(+total.toFixed(2)).toString()}`
        : `Total Hours: ${(+total.toFixed(2)).toString()}`;
    }
    return '';
  });
};
